export const IntegrationStatus = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  UPCOMING: 'upcoming',
  ERROR: 'error',
};

export const INTEGRATION_STATUS_LABELS = {
  [IntegrationStatus.CONNECTED]: 'Connected',
  [IntegrationStatus.DISCONNECTED]: 'Disconnected',
  [IntegrationStatus.UPCOMING]: 'Coming Soon',
  [IntegrationStatus.ERROR]: 'Error',
};
